import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/data/catalog";

const WhatsAppFloat = () => (
  <motion.a
    href={waLink("Ciao! Vorrei informazioni sulle carte.")}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.4, type: "spring", stiffness: 120, damping: 14 }}
    whileHover={{ scale: 1.06 }}
    className="fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full bg-[#25D366] py-3 pl-4 pr-6 font-mono text-xs uppercase tracking-[0.15em] text-black shadow-[0_10px_40px_-5px_rgba(37,211,102,0.5)]"
  >
    <span className="relative flex h-8 w-8 items-center justify-center">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-black/20" />
      <MessageCircle size={18} strokeWidth={2.5} />
    </span>
    Scrivici
  </motion.a>
);

export default WhatsAppFloat;
